import { normalizeCheckoutConfig } from "../utils/checkoutFormConfig";
import { getConfig } from "../utils/getConfig";

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  return hostname.split(".")[0];
};

/**
 * Fetches partner config from n8n only (no static fallback).
 * The returned object is passed through {@link normalizeCheckoutConfig} so
 * pricing and summary flags (`applyDeliveryFee`, `showDeliveryFeeInSummary`, etc.)
 * are filled when omitted by n8n (defaults derived from `id` only).
 * @returns {Promise<{
 *   id: string,
 *   noCheckout?: boolean,
 *   requiredFields: string[],
 *   itemPriceFieldTTC: string,
 *   itemPriceFieldHT?: string,
 *   deliveryCost: number,
 *   deliveryFreeThreshold: number,
 *   discount?: number,
 *   partnerEmail: string|null,
 *   subdomainEmail?: string|null,
 *   pricesOverride?: Record<string, number>,
 *   partnerCommissionRate?: number,
 *   partnerCommissionPercent?: number,
 *   applyDeliveryFee?: boolean,
 *   applyPartnerDiscount?: boolean,
 *   showDeliveryFeeInSummary?: boolean,
 *   showPartnerDiscountInSummary?: boolean,
 *   checkoutForm?: {
 *     delivery: { required: string[], optional?: string[], readOnlyKeys?: string[] },
 *     billing: null | { required: string[], optional?: string[] },
 *     companyWhenChecked: null | { required: string[] }
 *   }
 * }>}
 * @param {{ subdomainOverride?: string }} [options]
 */
export const fetchConfig = async (options = {}) => {
  const overrideRaw = options.subdomainOverride;
  const subdomainOverride =
    typeof overrideRaw === "string" ? overrideRaw : undefined;
  const { subdomainEmail, ...rest } = await getConfig(subdomainOverride);
  return normalizeCheckoutConfig({
    ...rest,
    partnerEmail: subdomainEmail ?? null,
  });
};
